@if (facetCategory()) {
  <cdk-accordion-item
    [attr.data-test]="'facet-list-panel--category-' + facetCategory().code + '-accordion'"
    class="facet-list"
    #accordionItem="cdkAccordionItem"
    tabindex="0"
    [attr.id]="'facet-list-header-' + facetCategory().code"
    [attr.aria-expanded]="accordionItem.expanded"
    [attr.aria-controls]="'facet-list-body-' + facetCategory().code"
    [expanded]="selected()"
  >
    <div
      [attr.data-test]="'facet-list-panel--category-' + facetCategory().code + '-accordion-header'"
      class="facet-list--header h-300" role="button" (click)="accordionItem.toggle()"
      [ngClass]="{'facet-list--header__expanded': accordionItem.expanded}"
    >
      {{ facetCategory().name }}
      <mat-icon class="facet-list--caret" svgIcon="arrow-down"></mat-icon>
    </div>
    @if (accordionItem.expanded) {
      <div
        @fadeInContentByHeightOpacity
        class="facet-list--body"
        role="region"
        [attr.id]="'facet-list-' + facetCategory().code"
        [attr.aria-labelledby]="'facet-list-header-' + facetCategory().code"
        [attr.data-test]="'facet-list-panel--category-' + facetCategory().code + '-body'"
      >
        @for (facet of facetCategory().facets; track facet.name) {
          @switch (facet.specialFacetType) {
            @case (specialFacetTypes.SEARCH) {
              <dp-facet-search
                [facet]="facet"
                [attr.data-test]="'facet-list-panel--category-' + facetCategory().code + '-facet-' + facet.facetCode"
              />
            }
            @case (specialFacetTypes.RANGE) {
              <dp-facet-range
                [facet]="facet"
                [attr.data-test]="'facet-list-panel--category-' + facetCategory().code + '-facet-' + facet.facetCode"
              />
            }
            @default {
              <dp-facet
                [facet]="facet"
                [attr.data-test]="'facet-list-panel--category-' + facetCategory().code + '-facet-' + facet.facetCode"
              />
            }
          }
        }
      </div>
    }
  </cdk-accordion-item>
}
